import { rexReducer as rex } from "@icg360/rex";
import { combineReducers } from "redux";

import { paymentPlan } from "./payment-plan";
import { adminMode } from "./admin-mode";
import { contacts } from "./contacts";
import { envInfo } from "./env-info";
import { esign } from "./esign";
import { esignPreBind } from "./esign-prebind";
import { featureFlags } from "./feature-flags";
import { messages } from "./messages";
import { notices } from "./notices";
import { quoteGrid } from "./quote-grid";
import { policyGrid } from "./policy-grid";
import { quoteQuickStart } from "./quote-quick-start";
import { quoteView } from "./quote-view";
import { policyView } from "./policy-view";
import { quoteTransactionComponent } from "./quote-transaction-component";
import { users } from "./users";
import { ipm } from "./ipm";

import type { Message, Notices } from "../components/messages/types";
import type { State } from "@icg360/rex";

export interface ApState {
  messages: Message[];
  notices: Notices;
  rex: State["rex"];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export default combineReducers<ApState>({
  adminMode,
  contacts,
  envInfo,
  esign,
  esignPreBind,
  featureFlags,
  ipm,
  messages,
  notices,
  paymentPlan,
  quoteGrid,
  policyGrid,
  policyView,
  quoteQuickStart,
  quoteView,
  quoteTransactionComponent,
  rex,
  users
});
